import { useState } from "react"

interface SerachProps {
    search: string
    onChange: (s: string) => void
}

const SearchComponent = (props: SerachProps) => {
    const [search, setSearch] = useState(props.search)
    return (
        <div className="w-[300px] mt-2 sm:mt-0">
            <input type="text" placeholder="Search...." defaultValue={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === "Enter" && props.onChange(search)} className="w-full rounded-md border-[1.5px] border-stroke bg-transparent py-1.5 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary" />
        </div>
    )
}

export default SearchComponent